import type { FaireProductEntity } from "../../entity_types/product";

export const p_yjaheeqeq3: FaireProductEntity = {
  token: "p_yjaheeqeq3",
  type: "product",
  name: "Kuromi™ x Touchland Hand Sanitizer Set",
  brandToken: "b_evrq835k7x",
  brandName: "Touchland",
  imageUrl: "https://cdn.faire.com/fastly/2e657f8288c72588ed7ea196cb31bd37e327e265d766ce89b93e4e11d7883331.webp",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/f7412eb166624916447460bc1190208dbe0853894f69f92798dcb587dce58aea.webp",
    "https://cdn.faire.com/fastly/794544c7effb9ab21bb1cc85f3a69df73d5bad80963bd56d384f5d0f26f7bf74.webp",
    "https://cdn.faire.com/fastly/46cdd954c94969d76f5f06f7d0b9c441f1394ee9b396fcb7a084af541a392ee2.webp",
    "https://cdn.faire.com/fastly/0873a9b368c436d4a0bec23eaec658cbc47fc61e78850ae85a7264a42bdd1e82.webp",
    "https://cdn.faire.com/fastly/22b0caa5a687edcad59ca815819d0e9db79e3fbec1eed5bd7f6f5f1f4519efd4.webp",
    "https://cdn.faire.com/fastly/7f292c36dfcd09f7f94136e87a8b7fda71def9d0eb2cffdc51f1ab6057c42cb5.webp"
  ],
  priceDollars: 10,
  description: "Sweet with a smirk. The special edition Kuromi x Touchland Set brings out the mischievous side of our cotton candy scent. Collectible, clip-worthy, and pretty unpredictable.\n\nFragrance: Cotton Candy. Pink strawberry and blue raspberry mingle with candied raspberry, spun sugar, and vanilla bean for a candy-coated delight.\n\nMain Ingredients:\n• Alcohol: Effective against most common bacteria.\n• Aloe Vera: Helps hydrate skin and leaves a non-greasy finish.\n• Radish Root Ferment Filtrate: Helps enhance skin’s moisture retention.\n\n\nKuromi™ x Touchland Cotton Candy Hand Sanitizer Mist:\n• Dermatologically tested\n• Free of phthalates, sulfates and dyes\n• Travel-friendly\n• Dye-free\n• Vegan & Cruelty-free \n• Made in USA\n• 1 FL. OZ. (30 mL)\n\nKuromi™ x Touchland Hand Mist Case:\n• Compatible with all Touchland hand sanitizer mists 1 FL. OZ. (30mL)\n• Silicone case\n• Metal keyring",
  tags: [],
  msrpDollars: 20,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-10-28T21:07:34.789Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
